const CAMPAIGN_BANNER_DISMISS_KEY = 'campaign.signupBonus.dismissed';

function resolveStorage(storage) {
  if (storage) {
    return storage;
  }
  if (typeof window === 'undefined') {
    return null;
  }
  return window.sessionStorage ?? null;
}

function getSignupCampaignBannerDismissed(storage) {
  const targetStorage = resolveStorage(storage);
  if (!targetStorage) {
    return false;
  }
  const value = targetStorage.getItem(CAMPAIGN_BANNER_DISMISS_KEY);
  return value === '1' || value === 'true';
}

function dismissSignupCampaignBanner(storage) {
  const targetStorage = resolveStorage(storage);
  if (!targetStorage) {
    return;
  }
  targetStorage.setItem(CAMPAIGN_BANNER_DISMISS_KEY, '1');
}

export {
  CAMPAIGN_BANNER_DISMISS_KEY,
  dismissSignupCampaignBanner,
  getSignupCampaignBannerDismissed
};
